export default {"src":"/_next/static/media/square_white.cbbe41a6.svg","height":125,"width":128,"blurWidth":0,"blurHeight":0};